import ExamImage from "../components/ExamImage";
import QuestionLayout from "./QuestionLayout";

export default function ImageChoiceWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const selected = value.choice || "";

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16
        }}
      >
        <ExamImage
          src={config.image}
          alt={config.alt || ""}
          style={{
            maxWidth: config.imageWidth || 420,
            maxHeight: config.imageHeight || 220,
            objectFit: "contain"
          }}
        />

        <div style={{ display: "flex", gap: 12 }}>
          {config.answerMode === "text" ? (
  <input
    value={value.text || ""}
    disabled={mode !== "edit"}
    onChange={(e) =>
      onChange({
        ...value,
        text: e.target.value
      })
    }
    style={{
      width: config.inputWidth || 220,
      height: 38,
      fontSize: 18,
      padding: "4px 8px",
      textAlign: config.textAlign || "center",
      border:
        mode === "review"
          ? feedback?.parts?.text?.correct
            ? "2px solid #2e7d32"
            : "2px solid #c62828"
          : "1px solid #aaa",
      borderRadius: 6
    }}
  />
) : (
  <div style={{ display: "flex", gap: 12 }}>
    {(config.choices || []).map((choice) => {
      const isSelected = selected === choice.value;

      return (
        <button
          key={choice.value}
          type="button"
          disabled={mode !== "edit"}
          onClick={() =>
            onChange({
              ...value,
              choice: choice.value
            })
          }
          style={{
            fontSize: 16,
            padding: "8px 18px",
            borderRadius: 6,
            cursor: mode === "edit" ? "pointer" : "default",
            background: isSelected ? "#e3f2fd" : "#fff",
            border:
              mode === "review" && isSelected
                ? feedback?.parts?.choice?.correct
                  ? "2px solid #2e7d32"
                  : "2px solid #c62828"
                : isSelected
                ? "2px solid #1976d2"
                : "1px solid #aaa"
          }}
        >
          {choice.label}
        </button>
      );
    })}
  </div>
)}
        </div>
      </div>
    </QuestionLayout>
  );
}